/**
 * Returns a date timestamp
 * FIXME: this is not a selector
 *
 * @returns {Number}
 * */
export const getUnixTimestamp = () => new Date().valueOf() / 1000;
